import { brandPrimary, navigation } from '../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'block',
		minHeight: 300,
		minWidth: 600,
		position: 'relative',
	},

	jobList: {
		fontSize: 14,
		maxHeight: 500,
		overflowY: 'auto',
	},
	noneFound: {
		color: navigation,
		letterSpacing: 1.1,
		marginTop: 30,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	revertCheckbox: {
		marginTop: 20,
	},
	sectionTitle: {
		color: '#858585',
		fontSize: 16,
		letterSpacing: 1,
		paddingTop: 20,
		textTransform: 'uppercase',
	},
	title: {
		color: brandPrimary,
		fontSize: 22,
		fontWeight: 600,
		maxWidth: '80%',
		position: 'absolute',
		top: -20,
	},
});
